const config = {
  baseURL: process.env.REACT_APP_BASE_URL || "https://api.routeeye.io/api",
  isDemo: process.env.REACT_APP_IS_DEMO === 'true' || false,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyD7rqUpTzUpEbxm-Xc7ikltFJGzOhd92Qk",
  pages: {
    login_page: {
      header: process.env.REACT_APP_LOGIN_HEADER || "Login Here"
    }
  }
};

export default config; 